export default "/images/f41755ae7a86bf2298c481f0a0d364b0.avif";